import smartSolveApi from './instances/smartsolve';
import { downloadFile } from '../utils/domUtils';

export const getAvailableWorkflows = async () => {
  try {
    const response = await smartSolveApi.get('/application-migrations/workflows');

    return response.data;
  } catch (error) {
    throw new Error(`getAvailableWorkflows() failed: ${error}`);
  }
};

export const getDefaultChangedItems = async () => {
  try {
    const response = await smartSolveApi.get('/application-migrations/entities');

    return response.data;
  } catch (error) {
    throw new Error(`getDefaultChangedItems() failed: ${error}`);
  }
};

export const appMigrationExportPreview = async (params) => {
  const formData = new FormData();

  formData.append('file', params.file);
  formData.append('request', JSON.stringify(params.request));

  try {
    const response = await smartSolveApi.post('/application-migrations/preview', formData);

    return response.data;
  } catch (error) {
    throw new Error(`appMigrationExportPreview() failed: ${error}`);
  }
};

export const appMigrationExport = async (params) => {
  try {
    const response = await smartSolveApi.post('/application-migrations/export', params);

    return response.data;
  } catch (error) {
    throw new Error(`appMigrationExport() failed: ${error}`);
  }
};

export const appMigrationSaveBuildFile = async (params) => {
  try {
    const response = await smartSolveApi.post('/application-migrations/savebuildfile', params);

    return response.data;
  } catch (error) {
    throw new Error(`appMigrationSaveBuildFile() failed: ${error}`);
  }
};

export const appMigrationExportDownload = async ({ targetDirectoryName = '' }) => {
  try {
    const response = await smartSolveApi.get(
      `/application-migrations?targetDirectoryName=${targetDirectoryName}`,
      {
        responseType: 'blob',
      }
    );

    downloadFile(`${targetDirectoryName}.zip`, response.data);
  } catch (error) {
    throw new Error(`appMigrationExportDownload() failed: ${error}`);
  }
};

export const appMigrationDownloadFile = async ({ importKey, fileName }) => {
  try {
    const { data, headers } = await smartSolveApi.post(
      '/application-migrations/files',
      {
        ImportEntityKey: importKey,
        FileName: fileName,
      },
      {
        responseType: 'blob',
      }
    );

    return { data, headers };
  } catch (error) {
    throw new Error(`appMigrationDownloadFile() failed: ${error}`);
  }
};

export const uploadAppMigrationImport = async (file) => {
  const formData = new FormData();

  formData.append('FileName', file.name);
  formData.append('FileDescription', '');
  formData.append('FileStream', file);

  const response = await smartSolveApi.post('/application-migrations/uploadimportfile', formData);

  try {
    return response.data;
  } catch (e) {
    throw new Error(`uploadAppMigrationImport() failed: ${e}`);
  }
};

export const appMigrationImport = async (params) => {
  try {
    const formData = new FormData();
    formData.append('file', params.file);
    formData.append('request', JSON.stringify(params.request));

    const response = await smartSolveApi.post('/application-migrations/processimport', formData);

    return response.data;
  } catch (e) {
    throw new Error(`appMigrationImport() failed: ${e}`);
  }
};

export const appMigrationImportStatus = async ({ importKey, appMigrationZipFileId }) => {
  try {
    const response = await smartSolveApi.post('/application-migrations/getstatus', {
      importKey,
      appMigrationZipFileId,
    });

    return response.data;
  } catch (e) {
    throw new Error(`appMigrationImportStatus() failed: ${e}`);
  }
};

export const appMigrationCancel = async (params) => {
  try {
    const response = await smartSolveApi.post('/application-migrations/cancel', params);

    return response.data;
  } catch (e) {
    throw new Error(`appMigrationCancel() failed: ${e}`);
  }
};

export const appMigrationInsertActivityLog = async (params) => {
  try {
    const response = await smartSolveApi.post(
      '/application-migrations/cleanandsendnotification',
      params
    );

    return response.data;
  } catch (error) {
    throw new Error(`appMigrationInsertActivityLog() failed: ${error}`);
  }
};
